import React from 'react';
import './OurClients.css';
import Checkout from '../components/Checkout';

const OurClients = () => {
  return (
    <>
      <div className="our-clients">
        <h1>Our Clients</h1>
        <p>We're currently upgrading—Our clients content coming soon!</p>
      </div>
      <Checkout />
    </>
  );
};

export default OurClients;